import styled from 'styled-components';

export default styled.div`
  display: grid;
  margin-top: 0.5rem;
  grid-column-gap: 0.5rem;
`;
